import { Component} from '@angular/core';
import { BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-paragraph-lead',
    templateUrl: './block-paragraph-lead.component.html',
})

export class BlockParagraphLeadComponent extends BlockAbstractComponent {

}
